/** @format */

import { Auth } from '../modules/auth/Auth';
import { history } from './history';
import { debug } from './debug';

const axios = require('axios');
const _ = require('underscore');

export const apiCall = {
    get: (url, filter, orders) => {
        const headers = apiCall.getHeaders();
        return axios
            .get(apiCall.buildUrlFilter(url, filter, orders), { headers: headers })
            .then((response) => {
                if (response.status === 200 || _.has(response, 'data')) {
                    return response.data;
                }
                return Promise.reject({ message: 'No response data from server' });
            })
            .catch((error) => {
                return apiCall.checkErrorResponse(error);
            });
    },

    getWithResponse: (url, filter, orders) => {
        const headers = apiCall.getSimpleHeaders();
        return axios
            .get(apiCall.buildUrlFilter(url, filter, orders), { headers: headers })
            .then((response) => {
                if (response.status === 200 || _.has(response, 'data')) {
                    return response;
                }
                return Promise.reject({ message: 'No response data from server' });
            })
            .catch((error) => {
                return apiCall.checkErrorResponse(error);
            });
    },

    remove: (url) => {
        const headers = apiCall.getHeaders();
        return axios
            .delete(url, { headers: headers })
            .then((response) => {
                if (response.status === 204) {
                    return response;
                }
                return Promise.reject({ message: 'No response data from server' });
            })
            .catch((error) => {
                debug(error);
                return apiCall.checkErrorResponse(error);
            });
    },

    post: (url, params) => {
        const headers = apiCall.getHeaders();
        const jsonParams = JSON.stringify(params);
        return axios
            .post(url, jsonParams, { headers: headers })
            .then((response) => {
                if (response.status === 201 || _.has(response, 'data')) {
                    return response.data;
                }
                return Promise.reject({ message: 'Cant create new object' });
            })
            .catch((error) => {
                return apiCall.checkErrorResponse(error);
            });
    },

    put: (url, param) => {
        const headers = apiCall.getHeaders();
        return axios
            .put(url, param, { headers: headers })
            .then((response) => {
                if (response.status === 201 || _.has(response, 'data')) {
                    return response.data;
                }
                return Promise.reject({ message: 'Cant create new object' });
            })
            .catch((error) => {
                return apiCall.checkErrorResponse(error);
            });
    },

    patch: () => {
        return Promise.reject('not implemented on API!');
    },

    uploadFile: (url, formData) => {
        const headers = apiCall.getMultiPartHeaders();
        return axios.post(url, formData, { headers: headers });
    },

    uploadFileCustom: (url, formData) => {
        const headers = apiCall.getMultiPartHeaders();
        return axios
            .post(url, formData, { headers: headers })
            .then((response) => {
                if (response.status === 201 || _.has(response, 'data')) {
                    return response.data;
                }
                return Promise.reject({ message: 'Cant create new object' });
            })
            .catch((error) => {
                return apiCall.checkErrorResponse(error);
            });
    },

    getHeaders: () => {
        const token = Auth.getBearerAccessToken();
        const lang = Auth.getTranslationLang();
        return {
            'X-Requested-With': 'XMLHttpRequest',
            Authorization: token,
            Accept: '*/*',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            'Content-Language': lang,
        };
    },

    getSimpleHeaders: () => {
        const token = Auth.getBearerAccessToken();
        const lang = Auth.getTranslationLang();
        return {
            Authorization: token,
            Accept: '*/*',
            'Content-Language': lang,
        };
    },

    getMultiPartHeaders: () => {
        const token = Auth.getBearerAccessToken();
        const lang = Auth.getTranslationLang();
        return {
            Authorization: token,
            Accept: '*/*',
            'Cache-Control': 'no-cache',
            'Content-Type': 'multipart/form-data',
            'Content-Language': lang,
        };
    },

    checkErrorResponse: (error) => {
        if (error.response) {
            debug('Error response');
            debug(error.response);
            checkUnauthorizeResponse(error.response);
            const errorResponse = apiCall.returnErrorFromResponse(error.response.data);
            return Promise.reject({
                message: errorResponse,
                status: error.response.status,
                statusText: error.response.statusText,
            });
        } else if (error.request) {
            debug('Error request');
            debug(error.request);
            return Promise.reject({
                message: 'Network error',
                status: 500,
                statusText: 'Network error',
            });
        } else {
            debug('unknow error');
        }
    },

    returnErrorFromResponse: (error) => {
        debug(error);
        if (error.violations) {
            return error.violations;
        }
        if (error['hydra:description']) {
            return { message: error['hydra:description'], title: error['hydra:title'] };
        }
        return [{ message: 'An error occured' }];
    },

    buildUrlFilter: (url, filter, orders) => {
        if (url.indexOf('page') !== -1) {
            return url;
        }
        const index = url.indexOf('?');
        if (filter || orders) {
            if (index !== -1) {
                url = url.substr(0, index);
            }
            url = url + '?';
        }
        if (filter) {
            for (let i = 0; i < filter.length; i++) {
                if (i > 0) {
                    url += '&';
                }
                url += filter[i].name + '=' + filter[i].value;
            }
        }
        if (orders) {
            for (let i = 0; i < orders.length; i++) {
                url += '&order[' + orders[i].name + ']=' + orders[i].value;
            }
        }
        return url;
    },
};

function checkUnauthorizeResponse(response) {
    if (response.status === 401 && response.statusText === 'Unauthorized') {
        Auth.clearToken();
        history.push(window._ROOT_LOGIN_PROVIDER);
    }
}
